import React from 'react'
import { withRouter, Link } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectCurrentFundraisingPage } from '../../../store/fundraisingPage'
import { clearSession, selectPage, selectUser } from '../../../store/session'
import { selectCustomSupporterPagePresent } from '../../../store/customSupporterPages'

const LinkHandler = ({
  clearSession,
  currentPage,
  linkType,
  hasCustomSupporterPages,
  onClick,
  page = {},
  user = {},
  to,
  ...props
}) => {
  const isButton = () => !to && onClick
  const isExternalLink = () => to && /^((ftp|http|https):\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,24}\b([-a-zA-Z0-9@:%_+.,~#?&//=]*)$/.test(to)
  const isMailtoLink = () => to && to.indexOf('mailto') === 0
  const isAnchorLink = () => to && to.replace('/', '').indexOf('#') === 0

  if (linkType === 'login' && user.token) {
    return <button {...props} onClick={clearSession}>Logout</button>
  }

  if (linkType === 'signup' && page.id) {
    if (hasCustomSupporterPages) {
      return <Link {...props} onClick={onClick} to={`/fundraising/${page.slug}`}>View Page</Link>
    } else {
      return <a href={page.url} target='_blank' {...props}>View Page</a>
    }
  }

  if (linkType === 'donate' && currentPage) {
    return <a {...props} href={currentPage.donationUrl} target='_blank' />
  }

  if (isButton()) {
    return <button onClick={onClick} {...props} />
  }

  if (isExternalLink()) {
    return <a {...props} href={to} target='_blank' />
  }

  if (isMailtoLink()) {
    return <a href={to} {...props} />
  }

  if (isAnchorLink()) {
    return <a href={to} {...props} />
  }

  return <Link onClick={onClick} to={to} {...props} />
}

const mapState = (state, props) => ({
  ...selectCustomSupporterPagePresent(state),
  currentPage: selectCurrentFundraisingPage(state, props),
  page: selectPage(state),
  user: selectUser(state)
})

const mapDispatch = { clearSession }

export default compose(
  withRouter,
  connect(mapState, mapDispatch)
)(LinkHandler)
